<div class="main-db gap-top">

<div class="agm-container">
    <!-- <agm-map
      [zoom]="20"
      [latitude]="lat"
      [longitude]="lng"
      (mapReady)="onMapReady($event)"
    >
    </agm-map> -->
    <agm-map [latitude]="center.lat" [longitude]="center.lng" (mapReady)="onMapReady($event)" [zoom]="mapZoom"
	  [mapTypeId]="mapType">
	    <agm-polygon [fillColor]="polygonData.fillColor" [fillOpacity]="polygonData.fillOpacity"
         [polyDraggable]="false" [paths]="polygonData.ZonePaths"  [hidden]="createPolygon" [clickable]="true" (polyMouseOver)="viewInfo()" (polyMouseOut)="closeInfo()">
          <agm-info-window [latitude]="center.lat" [longitude]="center.lng" [isOpen]="info">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title">{{geofenceName}}</h5>
              </div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item" *ngFor="let zone of zoneList">{{getZoneName(zone)}}</li>
              </ul>
            </div>
          </agm-info-window>
      </agm-polygon> 

      <agm-polygon [fillColor]="polygonData.fillColor" [fillOpacity]="polygonData.fillOpacity" [strokeOpacity]="0.5" 
       [polyDraggable]="false" *ngFor="let polygon of allGeofenceDetails" [paths]="polygon" 
       [hidden]="createPolygon" [clickable]="true">

    </agm-polygon> 
    </agm-map>

  	<select class="form-control bg-dark text-white select-l"  #mySelect
      (change)='wt(mySelect.value)'  [(ngModel)]="mapType">
      <option value="terrain">Map</option>
      <option value="satellite">Satellite</option>     
    </select>
    <br />
    <input type="text" class="search-l form-control" id="pac-input" placeholder="Search Map" />
    <!-- <button class="btn btn-success btnZone" data-widget="control-sidebar" href="#">Add Zone</button> -->

    <div class="form-group actionView">
     <div class="geofenceName">{{geofenceName}}</div>
     <div class="saveDeleteGeoBtn">
      <input class="btn btn-success btn-sm" type="button" value="Save Geofence Detail" (click)="saveGeoFenceDetail()" [hidden] = "!createPolygon">
      <input class="btn btn-danger btn-sm" type="button" value="Delete Geofence Detail" (click)="removeGeoFenceDetail()" [hidden] = "createPolygon">
     </div>
    </div>

    <div class="zone-btn">
      <button class="btn btn-success" style="width: 120px;" data-widget="control-sidebar" href="#">Add Zone</button>
    </div>
<!-- 
    <div class="zone-box">
      <div class="check-box" *ngFor="let data of zoneData">
        <input type="checkbox" (change)="onChange(data.zoneId, $event.target.checked)" [checked]="inputChecked(data.zoneId)"> {{data.zoneId}}
      </div> 
    </div> -->
  </div>

  <!-- <div class="back-btn">
    <button class="btn btn-danger" (click)="goBack()">Back</button>
  </div> -->

  </div>

  <aside class="control-sidebar control-sidebar-dark" style="width: 400px;">
    <div class="p-3 h-100 overflow-auto" style="overflow: auto;">
      
      <a class="float-right" data-widget="control-sidebar" href="#"><mat-icon>close</mat-icon></a>
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        <li class="nav-item menu-is-opening menu-open">
          <a href="#" class="nav-link pl-0 font-weight-bold">
            <i class="nav-icon fas fa-copy"></i>
            Parkmobile
              <i class="fas fa-angle-left right"></i>
          </a>
          <ul class="nav nav-treeview" style="display: block;">
            <li  class="nav-item" *ngFor="let data of zoneData"  >
              <a *ngIf="data.description == 'Parkmobile'" class="nav-link check-box">
                <label class="font-weight-light">
                  <input type="checkbox" (change)="onChange(data.zoneId, $event.target.checked)"
                  [checked]="inputChecked(data.zoneId)"> {{data.zoneId}} - {{data.zoneName}}
                </label>
              </a>
            </li>
          </ul>
          </li>
      </ul>

      <hr class="dashed">

      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        <li class="nav-item menu-is-opening menu-open">
          <a href="#" class="nav-link pl-0 font-weight-bold">
            <i class="nav-icon fas fa-copy"></i>
            Flowbird
              <i class="fas fa-angle-left right"></i>
          </a>
          <ul class="nav nav-treeview" style="display: block;">
            <li  class="nav-item" *ngFor="let data of zoneData"  >
              <a *ngIf="data.description == 'Flowbird'" class="nav-link check-box">
                <label class="font-weight-light">
                  <input type="checkbox" (change)="onChange(data.zoneId, $event.target.checked)"
                  [checked]="inputChecked(data.zoneId)"> {{data.zoneId}} - {{data.zoneName}}
                </label>
              </a>
            </li>
          </ul>
          </li>
      </ul>

      <hr class="dashed">

      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        <li class="nav-item menu-is-opening menu-open">
          <a href="#" class="nav-link pl-0 font-weight-bold">
            <i class="nav-icon fas fa-copy font"></i>
            Permitted
              <i class="fas fa-angle-left right"></i>
          </a>
          <ul class="nav nav-treeview" style="display: block;">
            <li  class="nav-item" *ngFor="let data of zoneData"  >
              <a *ngIf="data.description == 'Permitted'" class="nav-link check-box">
                <label class="font-weight-light">
                  <input type="checkbox" (change)="onChange(data.zoneId, $event.target.checked)"
                  [checked]="inputChecked(data.zoneId)"> {{data.zoneId}} - {{data.zoneName}}  
                </label>
              </a>
            </li>
          </ul>
          </li>
      </ul>

      <div class="float-left w-100">
        <button class="btn btn-sm btn-success" id="btn_zoneSave" 
        (click)="deleteGeofenceZoneByGeofenceId(geofenceId)" data-widget="control-sidebar" href="#">Save</button>
      </div>
      
      <!-- <div class="zone-box">
        <div class="float-left w-100">
          <button class="btn btn-sm btn-danger" data-widget="control-sidebar" href="#">X</button>
        </div>
        <div class="check-box" *ngFor="let data of zoneData">
          <input type="checkbox" (change)="onChange(data.zoneId, $event.target.checked)" [checked]="inputChecked(data.zoneId)"> {{data.zoneId}}
        </div> 
        <div class="float-left w-100">
          <button class="btn btn-sm btn-success" (click)="deleteGeofenceZoneByGeofenceId(geofenceId)" data-widget="control-sidebar" href="#">Save</button>
        </div>
      </div> -->

    </div>
  </aside>